"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCashedInRewards = exports.createRandomId = exports.createReward = exports.createRewardsOnPlayReq = void 0;
var crypto_random_string_1 = __importDefault(require("crypto-random-string"));
var interfaces_1 = require("../../../interfaces");
var createRewardsOnPlayReq = function (maxRewards) {
    if (maxRewards === void 0) { maxRewards = 12; }
    return {
        campaignId: "dfdfda2e-f7ff-4c69-861e-53e6f9bacab7",
        campaignTitle: "Test Mini Game",
        playerId: "2496869a-2adb-4f85-8050-ba7f872bdb70",
        rewards: Array(maxRewards).fill({}).map(function (_, idx) { return (0, exports.createReward)({ title: !(idx % 2) ? "50RonBonus" : "100RonBonus" }); }),
    };
};
exports.createRewardsOnPlayReq = createRewardsOnPlayReq;
var createReward = function (fields) { return ({
    id: (fields === null || fields === void 0 ? void 0 : fields.id) || (0, exports.createRandomId)(),
    amount: (fields === null || fields === void 0 ? void 0 : fields.amount) || 20000,
    title: (fields === null || fields === void 0 ? void 0 : fields.title) || "50RonBonus",
    type: (fields === null || fields === void 0 ? void 0 : fields.type) || interfaces_1.MiniGamesRewardTypes.Bonus,
    weight: (fields === null || fields === void 0 ? void 0 : fields.weight) || 5,
}); };
exports.createReward = createReward;
var createRandomId = function () { return (0, crypto_random_string_1.default)({ length: 7, type: "alphanumeric" }); };
exports.createRandomId = createRandomId;
var createCashedInRewards = function (requiredFields, fields) { return (__assign({ title: (fields === null || fields === void 0 ? void 0 : fields.title) || "", playerId: (fields === null || fields === void 0 ? void 0 : fields.playerId) || "alin_rada", amount: (fields === null || fields === void 0 ? void 0 : fields.amount) || 0, campaignId: (fields === null || fields === void 0 ? void 0 : fields.campaignId) || "dfhgfj", transactionId: (fields === null || fields === void 0 ? void 0 : fields.transactionId) || "#ty6t9uythdfodfhfg" }, requiredFields)); };
exports.createCashedInRewards = createCashedInRewards;
